module.exports = __webpack_public_path__ + "img/icon-pdf.fcbabab1.svg";